import moment from 'moment';
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';
import Data from '../../../../components/Display/Data';
import MultiLineData from '../../../../components/Display/MultiLineData';
import Section from '../../../../components/Display/Section';
import Tag from '../../../../components/Display/Tag';
import ImageItem from '../../common/image/ImageItem';
import { getConstant } from '../../../../utils/constants';
import DataTag from '../../../../components/Display/DataTag';
import MultipleDataTag from '../../../../components/Display/MultipleDataTag';

function PropertyDetail({ property, handleUpdateProperty, handleUpdateImages, handleDelete }) {
  const updateImagesActions = [
    {
      onClick: handleUpdateImages,
      label: 'Modifier les images',
      icon: 'pi-pencil'
    }
  ];

  const updatePropertyActions = [
    {
      onClick: handleUpdateProperty,
      label: 'Modifier les informations',
      icon: 'pi-pencil'
    }
  ];

  const confirmDeletion = (property) => {
    confirmDialog({
      message: 'Êtes-vous sûr de vouloir supprimer cette Propriété ?',
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      acceptLabel: 'Oui',
      rejectLabel: 'Annuler',
      accept: () => handleDelete(property)
    });
  };

  return (
    <div className={`h-full w-full flex-col flex gap-5`}>
      <Section label="Informations Générales" actions={updatePropertyActions}>
        <div className="flex flex-wrap gap-5">
          <Data key="title" label={'Titre'} value={property.title} large />
          <DataTag
            key="status"
            label={'Statut'}
            tag={{
              label: getConstant('shared.draftTypes', property.is_draft).label,
              bgColor: getConstant('shared.draftTypes', property.is_draft).bgColor
            }}
            large
          />
          <Data key="dept" label={'Département'} value={property.dept} large />
          <Data key="surface" label={'Surface'} value={`${property.surface} m²`} large />
          <Data key="price" label={'Prix'} value={`${property.price} €`} large />
          <DataTag
            key="availabilty"
            label={'Disponible'}
            tag={{
              label: property.availabilty ? 'Bien libre' : 'Bien occupé',
              bgColor: property.availabilty ? 'bg-green-700' : 'bg-green-950'
            }}
          />
          <DataTag
            key="sold"
            label={'Vendu'}
            tag={{
              label: property.sold ? 'Vendu' : 'Non vendu',
              bgColor: property.sold ? 'bg-purple-700' : 'bg-purple-950'
            }}
          />
        </div>
        <MultipleDataTag
          key="properties"
          label={'Points forts'}
          rounded
          tags={property.highlights.map((property) => ({
            label: property.label,
            bgColor: 'bg-orange-700'
          }))}
        />

        <div className="flex flex-wrap gap-5">
          <MultiLineData
            key="description"
            label={'Description'}
            value={property.description}
            large
            asHtml
          />
        </div>
      </Section>
      <Section label="Image principale">
        <ImageItem image={property.main_img} className="w-96" />
      </Section>
      <Section label="Autres images" actions={updateImagesActions}>
        <div className="flex flex-wrap gap-3">
          {!property.images.length && (
            <span className="italic text-slate-400 font-light">Aucune image à afficher</span>
          )}
          {property.images.map((img, index) => (
            <ImageItem
              key={index}
              image={img}
              alt={`Photo de ${property.title} n°${index}`}
              className="h-60"
            />
          ))}
        </div>
      </Section>
      <Section label="Autres actions">
        <div className="flex flex-row">
          <Button
            key={'delete'}
            label={'Supprimer la propriété'}
            className="!w-54"
            outlined
            onClick={() => confirmDeletion(property)}
            severity="danger"
          />
        </div>
      </Section>
    </div>
  );
}

export default PropertyDetail;
